import type {AppraisalAverageRating} from '~/types/domain/Appraisals';

export type RatingsItem = {
    numberOfRatings: number;
    general: number;
    communication: number;
    delay: number;
    quality: number;
};

export function toRatingItem(numberOfRatings: number, rating: AppraisalAverageRating): RatingsItem {
    return {
        numberOfRatings,
        general: rating?.general,
        communication: rating?.communication,
        delay: rating?.delay,
        quality: rating?.quality,
    };
}
